var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"data-table-loader"},_vm._l((10),function(index){return _c(_setup.SkeletonLoader,{key:index,staticClass:"data-table-loader__row"},_vm._l((7),function(index){return _c('div',{key:index,staticClass:"data-table-loader__column"})}),0)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }